
import { AfterViewInit, ChangeDetectorRef, Component, HostListener, Inject, Injectable, OnInit, ViewChild, DOCUMENT } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxMasonryComponent, NgxMasonryOptions } from 'ngx-masonry';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppComponent } from '../../app.component';
import { TileModalComponent } from '../../core/modals/tile-modal/tile-modal.component';
import { LogPage, LogType, LoggerService } from '../../core/services/logger.service';
import { ProfileService } from '../../core/services/profile.service';
import { AnnouncementsService } from '../../services/announcements.service';
import { BiddingService } from '../../services/bidding.service';
import { CountdownService, IInterval } from '../../services/countdown.service';
import { EnrollmentsService } from '../../services/enrollments.service';
import { KudosService } from '../../services/kudos.service';
import { WidgetHostBaseComponent } from '../../shared/widget/widgethostbase.component';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent extends WidgetHostBaseComponent implements OnInit, AfterViewInit {
    @Injectable()
    public myOptions: NgxMasonryOptions = {
            gutter: 5,
            columnWidth: '.grid-item',
            //fitWidth: true
    };

    public masonryContainer: HTMLElement;
    public modal: string;

    @ViewChild(NgxMasonryComponent) masonry: NgxMasonryComponent;

    public thisProfile$: Observable<any>;

    constructor(
        logger: LoggerService,
        public profileService: ProfileService,
        changeDetector: ChangeDetectorRef,
        public announcements: AnnouncementsService,
        public kudos: KudosService,
        public enrollments: EnrollmentsService,
        public bidding: BiddingService,
        public app: AppComponent,
        private modalService: NgbModal,
        private route: ActivatedRoute,
        private countdownService: CountdownService,
        @Inject(DOCUMENT) document,
        
    ) {
        super("DashboardComponent", profileService, logger, LogType.Page, LogPage.Dashboard, changeDetector);

        this.route.queryParamMap.
            subscribe(params => {
                if (params.get('m')) {
                    this.modal = params.get('m');
                }
            });

        // Handle case where querystring is included with modal name that's available to the user. If so, load it.
        this.thisProfile$ = this.profileService.profile$.pipe(
            tap((data) => {
                setTimeout(this.resizeMasonry, 300);
                if (data && data.components && data.components.modals && data.components.modals.includes(this.modal))
                {
                    this.openModal(false, '', this.modal, '');
                }
            })
        );

    }    

    @HostListener('window:resize', ['$event'])
    onResize(event: Event) {

        this.masonry.reloadItems();
        this.masonry.layout();

        setTimeout(this.resizeMasonry, 300);
    }

    public resizeMasonry() {
        
        this.masonryContainer = document.getElementById('masonryContainer');

        var masonryWidth = window.innerWidth;
        //190, 165, 145 tile sizes
        if (window.innerWidth > 769)
            masonryWidth = window.innerWidth - (window.innerWidth % 210);
        else if (window.innerWidth <= 769 && window.innerWidth >= 390)
            masonryWidth = window.innerWidth - (window.innerWidth % 185);
        else if (window.innerWidth < 390)
            masonryWidth = window.innerWidth - (window.innerWidth % 165);

        if (this.masonryContainer != null && this.masonryContainer.style != null) 
            this.masonryContainer.style.width = masonryWidth + 'px'
      
    }

    public openModal(showLeft: boolean, title: string, widgetName: string, modalSize: string) {
        //Handle case where the tile is just the old well image. Will need to figure how to handle this better later.
        if (widgetName == 'OldWell')
            return;

        var modalRef;
        if (modalSize == "" || modalSize == null)
            modalSize = "modal-lg"

        if (showLeft)
            modalRef = this.modalService.open(TileModalComponent, { windowClass: 'left' });
        else
            modalRef = this.modalService.open(TileModalComponent, {
                modalDialogClass: modalSize
            });

        modalRef.componentInstance.title = title;
        modalRef.componentInstance.componentName = widgetName;
    }

    public openLinksModal(title: string, widgetName: string, modalSize: string) {
        this.openModal(false, title, widgetName, modalSize);
    }


    public openTilePageModal(title: string, widgetName: string, pageID: string, labels: any, modalSize: any) {
        var modalRef;

        if (modalSize == "" || modalSize == null)
            modalSize = "modal-lg"

        //  The labelLookup in the profile only stores the title from the first label name in settings.
        //  Update the lookup when the tile is clicked to set the title appropriately.
        labels['TilePage'] = title;

        modalRef = this.modalService.open(TileModalComponent, {
            modalDialogClass: modalSize
        });

        modalRef.componentInstance.componentName = widgetName;
        modalRef.componentInstance.pageID = pageID;
    }

    public getBiddingCountDown$(auction): Observable<IInterval> {
        var nextState = auction.Timeline.find(s => s.NextState);
        if (nextState) {
            var endDate = new Date(nextState.Key);
            return this.countdownService.CountDown$(endDate);
        } else {
            var currentState = auction.Timeline.find(s => s.CurrentState);
            if (currentState) {
                var endDate = new Date(auction.AuctionEnds);
                return this.countdownService.CountDown$(endDate);
            } else {
                var firstState = auction.Timeline[0];
                var endDate = new Date(firstState.Key);
                return this.countdownService.CountDown$(endDate);
            }
        }
    }
}
